module.exports = __webpack_public_path__ + "static/media/206-gallery03.b0725607.jpg";